import http from '../../http'
import httpForm from '../../http-form'

const getCampaignApportionment = (id) => http.get(`apportionments/${id}`)

const createCampaignApportionment = (payload) => http.post('apportionments', payload)

const uploadCampaignApportionmentRules = (id, payload) => httpForm.patch(`apportionments/rules/${id}`, payload)

const removeCampaignApportionmentRules = (id) => http.delete(`apportionments/remove-apportionments-rules/${id}`)

const deleteCampaignApportionment = (apportionmentId, queries) => http.delete(`apportionments/${apportionmentId}?${queries || ''}`)

export {
  getCampaignApportionment,
  createCampaignApportionment,
  uploadCampaignApportionmentRules,
  deleteCampaignApportionment,
  removeCampaignApportionmentRules
}
